<template>
  <validation-provider
    v-slot="{ errors, valid, invalid, validated }"
    :rules="rules"
    :name="name"
  >
    <div
      class="custom-control custom-checkbox"
      :class="[
        { disabled: disabled },
        { [`custom-checkbox-${type}`]: type },
        inlineClass,
      ]"
    >
      <input
        :id="cbId"
        v-model="model"
        class="custom-control-input"
        :class="[inputClasses, { 'is-invalid': invalid && validated }]"
        type="checkbox"
        :disabled="disabled"
      />
      <label :for="cbId" class="custom-control-label">
        <slot></slot>
      </label>
    </div>
    <div
      v-if="errors[0] && showErrors"
      class="invalid-feedback"
      style="display: block"
    >
      {{ errors[0] }}
    </div>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'BaseCheckbox',
  components: {
    ValidationProvider,
  },
  model: {
    prop: 'checked',
  },
  props: {
    checked: {
      type: [Array, Boolean],
      description: 'Whether checkbox is checked',
    },
    disabled: {
      type: Boolean,
      description: 'Whether checkbox is disabled',
    },
    inline: {
      type: Boolean,
      description: 'Whether checkbox is inline',
    },
    inputClasses: {
      type: [String, Object, Array],
      description: 'Checkbox input classes',
    },
    type: {
      type: String,
      description: 'Checkbox type (e.g info, danger etc)',
    },
    rules: {
      type: [String, Object],
      description: 'Validation rules for the checkbox',
    },
    name: {
      type: String,
      description: 'Field name for validation',
    },
    showErrors: {
      type: Boolean,
      default: true,
      description: 'Whether to show validation error messages',
    },
  },
  data() {
    return {
      cbId: '',
      touched: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit('input', check);
      },
    },
    inlineClass() {
      if (this.inline) {
        return 'form-check-inline';
      } else {
        return '';
      }
    },
  },
  created() {
    this.cbId = Math.random().toString(16).slice(2);
  },
};
</script>

<style scoped>
/* Styles for the checkbox when there is an error */
.custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}

.custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #dc3545;
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label::before,
.custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: #fff;
}

/* Keep the label text in normal color */
.custom-control-input.is-invalid ~ .custom-control-label {
  color: inherit;
}

/* Ensure the label fits the size of the container */
.custom-control.custom-checkbox .custom-control-label {
  height: 100%;
}
</style>
